import { render } from "./PublicationDate.vue?vue&type=template&id=e4291976"
import script from "./PublicationDate.vue?vue&type=script&lang=js"
export * from "./PublicationDate.vue?vue&type=script&lang=js"
script.render = render

export default script